'use strict';
const { getQueryString } = require('@fe/common/lib/utils.js');
require('./faq.scss');

/**
 * dom节点加载完毕事件
 */
$(document).ready(function() {
  let search = location.href;
  let page = getQueryString('page', search);

  // 获取阿语数据
  const getArData = ()=> {
    $.get("/api/ar-feedback-data", {}, function (res) {
      if (res && res.status === 200) {
        let htmlStr = res.data;
        if (htmlStr) {
          $('#faq_wrap').addClass('ar-wrap');
          $('#faq_wrap').html(htmlStr);
        }
      }
    });
  }

  if (!page) { // 首页 校验是否为阿语内容
    let lang = getQueryString('lang', search);
    let sLang = navigator.language;
    // console.log("sLang:", sLang)
    let gLanguage = getQueryString('gLanguage', search);
    let gPLanguage = getQueryString('gPLanguage', search);
    if ( (window.vbrowser && window.vbrowser.getClientData("language")) ) {
      let lang = window.vbrowser.getClientData("language"); 
      if (Object.is(lang, 'ar')) { // 当前语言为阿语 请求对应数据重新渲染
        getArData();
      }
    } else if (Object.is(lang, 'ar') || (sLang && sLang.includes('ar')) || Object.is(gLanguage, 'ar') || Object.is(gPLanguage, 'ar')) {
      getArData();
    }
  }
});

